
import React, { Component } from 'react';
// import {  Text, View, TouchableOpacity} from 'react-native';
// import { StackNavigator } from 'react-navigation';
// import VersionNumber from 'react-native-version-number';

//type Props = {};
export default class Settings extends Component<{}> {
  static navigationOptions = {
    headerStyle: {
      backgroundColor: 'tranparent',
    }
  };

  clearCache() {
    localStorage.clear();
    window.location.reload();
    console.log("IN")
  }

  render() {
    // const { navigate } = this.props.navigation;

    return (
      <div className="flex-container">
        <div id="settings">
          <p>Current App Version: 1.0</p>
          <p>Current Cache Size: ???</p>
          <button onClick={this.clearCache.bind(this)}>Clear Cache</button>
        </div>
      </div>
    );
  }
}